export const environment = {
  production: false,
  apiUrl: '//tvg.pre-prod.net', // must not start with http:// or https:// otherwise HttpClient will not send X-XSRF-TOKEN header
  host: 'https://tvg.pre-prod.net',
  // Fallback only. resources/views/index.blade.php emits a
  // <meta name="asset-url"> tag that asset-url.util.ts prefers over this, so
  // the asset origin is decided server-side (see APP_URL / ASSET_URL).
  assetsPrefix: '',
  hideCustomerRulesConductTab: false,
};
